import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from 'react-bootstrap';

function EliminarSincronizarGoogle(props) {

    const navigate = useNavigate();

    const { usuario } = props; // contiene la url para volver: /cliente/mi-cuenta/eduardo2
   
    
    async function eliminarGoogle(event) {
        event.preventDefault();
        
        await axios.post("/eliminar-google", { usuario: usuario })
        .then(async function(response){
            if(response.status===200){
                alert("Google desincronizado correctamente.");
                window.location.reload();
            }
            else{
                alert("Error en el proceso. Vuelva a intentar.");
                window.location.reload();
            }
        });
    }


    

    return(
        <div>
            <button onClick={eliminarGoogle} className="btn btn-dark me-2 d-flex align-items-center justify-content-center w-100">
                <i className="bi bi-google me-2"></i>Desincronizar Google
            </button>
        </div>
    );
}

export default EliminarSincronizarGoogle;